'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = LoadingIndicator;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _SpacerElement = require('../../internal/SpacerElement');

var _SpacerElement2 = _interopRequireDefault(_SpacerElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  'spinner': 'ccl-337301f396e9cecc',
  'loadingIndicator': 'ccl-2e286961b397eb0a',
  'size18': 'ccl-7c7029c8edfe2c99',
  'size24': 'ccl-496f69f4fea03378',
  'size36': 'ccl-d084adca5e28e03b',
  'size48': 'ccl-ecdc3e0b0598332a',
  'teal': 'ccl-b6eb3a9626935242',
  'berry': 'ccl-b99dc0eb644a88b9',
  'aubergine': 'ccl-6087ad4f114a332d',
  'white': 'ccl-0e5070ecd76bacda'
};

/**
 * A loading indicator animation
 */

function LoadingIndicator(props) {
  var classes = (0, _classnames2.default)(styles.spinner, styles['size' + props.size], styles['' + props.color]);
  return _react2.default.createElement(
    _SpacerElement2.default,
    {
      element: 'span',
      spacing: props.spacing,
      adjacentVerticalSpacing: props.adjacentVerticalSpacing,
      adjacentHorizontalSpacing: props.adjacentHorizontalSpacing
    },
    _react2.default.createElement('span', { className: classes })
  );
}

LoadingIndicator.displayName = 'LoadingIndicator';
LoadingIndicator.propTypes = _extends({
  /**
   * The size of the loading indicator.
   */
  size: _propTypes2.default.oneOf([18, 24, 36, 48]),

  color: _propTypes2.default.oneOf(['teal', 'berry', 'aubergine', 'white'])

}, _SpacerElement2.default.propTypes);

LoadingIndicator.defaultProps = _extends({
  size: 18,
  color: 'teal'

}, _SpacerElement2.default.defaultProps);